<template>
    <div class="emailQueue__container">
        <div v-if="status=='processing'">
            <div class="overlay"></div>
            <div class="form-sending"></div>
        </div>
        <div class="queue-sender" v-if="status=='sent'">
            <div class="row">
                <div class="col-md-12">
                    <p>
                        <a href="/admin/dashboard?s=firstRun">Siirry tästä backstagelle</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Routes from '../modules/Routes';
    import Messages from '../modules/Messages';

    export default {
        mounted() {
            this.processEmail();
        },
        props: {
            queueHash: {
                type: String
            },
            ctaUrl: {
                type: String
            }
        },
        data() {
            return {
                status: 'processing'
            };
        },
        methods: {
            getUrl() {
                return Routes.getRoute('_public_api_flush_from_email_queue');
            },
            processEmail() {
                this.status = 'processing';
                this.$http.post(this.getUrl(), { hash: this.queueHash }, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then((response) => {
                    this.status = 'sent';
                    Messages.successFromResponse(response).then(() => {
                        window.location = '/admin/dashboard?s=firstRun';
                    });
                }, (response) => {
                    Messages.fromResponse(response);
                    this.status = 'error';
                });
            },
        }
    };
</script>
